import gql from 'graphql-tag';

export const QUERY_ASSIGNMENT_FEE_LEDGER = gql`
  query GetFeeLedger($assignment_id: ID!) {
    getFeeLedger(assignment_id: $assignment_id) {
      record_id
      amount
      assessed_on
      processed_on
      note
      is_voided
      assignment_id
      refunded_on
      invoice_id
      assignment {
        container {
          unique_name
          container_id
        }
        user {
          user_id

          user_membership {
            to
            from
            payment_processor_id
            paymentProcessor {
              name
            }
          }
        }
      }
    }
  }
`;

export const QUERY_USER_FEE_LEDGER = gql`
  query GetFeeLedgerPageByUser(
    $user_id: ID!
    $page: Int!
    $size: Int!
    $order: OrderInput
  ) {
    getFeeLedgerPageByUser(
      user_id: $user_id
      page: $page
      size: $size
      order: $order
    ) {
      total
      memberships {
        membership_id
        to
        from
        payment_processor_id
        paymentProcessor {
          name
        }
      }
      list {
        record_id
        assignment_id
        amount
        assessed_on
        processed_on
        note
        is_voided
        refunded_on
        assignment {
          container {
            unique_name
            container_id
          }
        }
      }
    }
  }
`;

export const MUTATION_VOID_FEE_LEDGER_RECORD = gql`
  mutation VoidFeeLedgerRecord($record_id: ID!) {
    voidFeeLedgerRecord(record_id: $record_id)
  }
`;

export const QUERY_FEE_LEDGER_RECORDS_TO_VOID = gql`
  query GetFeeLedgerRecordsToVoid($assignment_id: ID!) {
    getFeeLedgerRecordsToVoid(assignment_id: $assignment_id) {
      record_id
      amount
      assessed_on
      note
      assignment_id
      assignment {
        container {
          unique_name
          container_id
        }
      }
    }
  }
`;

export const MUTATION_VOID_FEE_LEDGER_RECORDS = gql`
  mutation VoidFeeLedgerRecords($record_ids: [ID!]!) {
    voidFeeLedgerRecords(record_ids: $record_ids)
  }
`;

export const QUERY_FEE_LEDGER_RECORDS_TO_REFUND = gql`
  query GetFeeLedgerRecordsToRefund($assignment_id: ID!) {
    getFeeLedgerRecordsToRefund(assignment_id: $assignment_id) {
      record_id
      amount
      assessed_on
      processed_on
      note
      assignment_id
      invoice_id
      assignment {
        clientLevel {
          corporate_client_id
        }
        container {
          unique_name
          container_id
        }
        user {
          user_id
          user_membership {
            to
            from
            payment_processor_id
            paymentProcessor {
              name
            }
          }
        }
      }
    }
  }
`;
